export default __webpack_public_path__ + "static/media/MSExcel_Security_5.2fd3cca4.png";